import { makeVar } from '@apollo/client';

export const shouldLoadChatWidgetScriptVar = makeVar(false);
export const chatWidgetOnLoadCallbackVar = makeVar<(() => void) | null>(null);
